/**
 * Pro Tips Card
 * Tips for maximizing XP and rewards
 */

import { Lightbulb } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

interface Tip {
  emoji: string;
  title: string;
  description: string;
}

export function ProTipsCard() {
  const { t } = useLanguage();

  const tips: Tip[] = [
    {
      emoji: '1',
      title: t('challenges.tips.share.title', 'Share Daily'),
      description: t(
        'challenges.tips.share.description',
        'Earn up to 550 XP per day by sharing on 3 platforms. The 3rd share gives you 300 XP!'
      ),
    },
    {
      emoji: '2',
      title: t('challenges.tips.streak.title', 'Build Your Streak'),
      description: t(
        'challenges.tips.streak.description',
        "Keep your streak alive by using Rumio daily. At 7 days, you'll earn the Daily Dedicated badge!"
      ),
    },
    {
      emoji: '3',
      title: t('challenges.tips.scan.title', 'Scan While Shopping'),
      description: t(
        'challenges.tips.scan.description',
        "Open the app when you're at IKEA's As-Is section. Each scan earns you 5 XP!"
      ),
    },
    {
      emoji: '4',
      title: t('challenges.tips.refer.title', 'Refer Friends'),
      description: t(
        'challenges.tips.refer.description',
        'Get 500 XP for each friend who qualifies. Plus, you both get 3 days of Pro!'
      ),
    },
  ];

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-100 rounded-2xl overflow-hidden">
      <div className="px-6 py-4 border-b border-blue-100">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Lightbulb className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {t('challenges.tips.title', 'Pro Tips')}
            </h2>
            <p className="text-sm text-gray-600">
              {t('challenges.tips.subtitle', 'Maximize your XP earnings')}
            </p>
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="space-y-4">
          {tips.map((tip, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-4 bg-white rounded-xl border border-blue-100"
            >
              <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                <span className="text-sm font-bold text-blue-600">{tip.emoji}</span>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 mb-1">{tip.title}</h4>
                <p className="text-sm text-gray-600">{tip.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
